import { Injectable, inject } from '@angular/core';
import { AccountGroupApiService, ProjectionFilter, ReadFilter } from '@galaxy/account-group';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BusinessNameService {
  private readonly accountGroupApiService = inject(AccountGroupApiService);
  private businessNameCache = new Map<string, string>();

  async loadBusinessName(accountGroupId: string): Promise<string> {
    if (this.businessNameCache.has(accountGroupId)) {
      const cachedName = this.businessNameCache.get(accountGroupId);
      return cachedName || accountGroupId;
    }

    try {
      const projection = new ProjectionFilter();
      projection.napData = true;
      const readFilter = new ReadFilter();
      readFilter.includeDeleted = true;

      const [accountGroup] = await firstValueFrom(
        this.accountGroupApiService.getMulti([accountGroupId], projection, readFilter),
      );

      const businessName = accountGroup?.napData?.companyName || accountGroupId;
      this.businessNameCache.set(accountGroupId, businessName);
      return businessName;
    } catch (error) {
      console.error('Error fetching business name:', error);
      this.businessNameCache.set(accountGroupId, accountGroupId);
      return accountGroupId;
    }
  }

  clearCache(): void {
    this.businessNameCache.clear();
  }

  clearCacheForAccountGroup(accountGroupId: string): void {
    this.businessNameCache.delete(accountGroupId);
  }
}
